import React, { createContext, useState, ReactNode } from 'react';

import { v4 as uuidv4 } from 'uuid';

interface DocumentViewerContextProps {
    comment: string;
    lineItem: string;
    attachment: string;
    handleSetCommentUpdated: () => void;
    handleSetLineItemUpdated: () => void;
    handleSetAttachmentUpdated: () => void;
}
export const DocumentViewerContext = createContext<DocumentViewerContextProps | undefined>(undefined);

export const DocumentViewerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [comment, setCommentUpdated] = useState<string>('');
    const [lineItem, setLineItemUpdated] = useState<string>('');
    const [attachment, setAttachmentUpdated] = useState<string>('');

    const handleSetCommentUpdated = () => {
        setCommentUpdated(uuidv4());
    };

    const handleSetLineItemUpdated = () => {
        setLineItemUpdated(uuidv4());
    };

    const handleSetAttachmentUpdated = () => {
        setAttachmentUpdated(uuidv4());
    };

    return (
        <DocumentViewerContext.Provider
            value={{ comment, lineItem, attachment, handleSetCommentUpdated, handleSetLineItemUpdated, handleSetAttachmentUpdated }}
        >
            {children}
        </DocumentViewerContext.Provider>
    );
};
